<script setup>
import { Link } from '@inertiajs/inertia-vue3'

const props = defineProps(['content','icon','type','link','isSubmit','normalLink','active','fullWidth','hideMobile','newWindow','disabled'])
const emit = defineEmits(['click'])
let basicStyles = "rounded-xl px-3 py-2 my-2 mr-2 ";
let buttonClass = `enriqueto-button`;
let standByClases = buttonClass+" "+basicStyles;
let activeClasses = '';
let buttonClasses = standByClases;

switch (props.type) {
    case '0':
        buttonClass = `enriqueto-button-add`;
        standByClases = 'border hover:bg-enriqueto_green hover:text-white hover:border-light_green border-enriqueto_green text-enriqueto_green';
        activeClasses = '';
        break;
    case '1':
        buttonClass = `enriqueto-button-tab`;
        standByClases = 'border hover:bg-enriqueto_green hover:text-white hover:border-light_green border-enriqueto_green text-enriqueto_green';
        activeClasses = 'border hover:bg-enriqueto_green hover:text-white hover:border-light_green border-enriqueto_green text-white bg-enriqueto_green';
        break;
    case '2':
        buttonClass = `enriqueto-button-simple`;
        standByClases = 'text-enriqueto_green hover:bg-light_yellow hover:shadow-md';
        activeClasses = '';
        break;
    case '3':
        buttonClass = `enriqueto-button-main`;
        standByClases = 'text-white bg-enriqueto_green hover:bg-light_yellow hover:shadow-md hover:text-enriqueto_green';
        activeClasses = '';
        break;
    case '4':
        buttonClass = `enriqueto-button-main`;
        standByClases = 'text-enriqueto_green bg-light_yellow hover:bg-light_yellow hover:shadow-md hover:text-enriqueto_green';
        activeClasses = '';
        break;
}
buttonClasses = buttonClass+" "+basicStyles+" "+standByClases;
if(props.disabled == true){
    buttonClasses = buttonClasses + " opacity-60 cursor-not-allowed";
}
if(props.active == true){
    buttonClasses = buttonClass+" "+basicStyles+" "+activeClasses;
}

if(props.fullWidth == true){
    buttonClasses = buttonClasses + " w-full";
}

if(props.hideMobile == true){
    buttonClasses = buttonClasses + " hidden md:flex ";
}else{
    buttonClasses = buttonClasses + " flex ";
}


const clickFunc = ()=>{
    emit('click');
}
</script>

<style scoped>
.material-symbols-outlined{
    font-size: 24px !important;
    margin-right: 5px;
    font-weight: bold;
}
a{
    width: fit-content;
    font-size: 16px !important;
}
a.w-full{
    width: 100% !important;
}
.enriqueto-button-main{
    justify-content: center;
}
.enriqueto-button-tab{
    
}
.enriqueto-button-simple .material-symbols-outlined{
    font-size: 18px !important;
}
</style>

<template>
    <button 
        v-if="link==null && !isSubmit"
        :disabled="disabled"
        class="items-center align-middle "  
        :class="buttonClasses"
        v-on:click="clickFunc">
            <span v-if="icon!=null" class="material-symbols-outlined">
                {{icon}}
            </span>
            {{content}}
    </button>
    <Link 
        v-if="link!=null && !isSubmit && !normalLink"
        :href="link"
        class="items-center align-middle "  
        :class="buttonClasses"
        v-on:click="clickFunc">
            <span v-if="icon!=null" class="material-symbols-outlined">
                {{icon}}
            </span>
            {{content}}
    </Link>
    <a 
        v-if="link!=null && !isSubmit && normalLink"
        :href="link"
        :target="newWindow ? '_blank' : null"
        :rel="newWindow ? 'noopener' : null"
        class="items-center align-middle "  
        :class="buttonClasses"
        v-on:click="clickFunc">
            <span v-if="icon!=null" class="material-symbols-outlined">
                {{icon}}
            </span>
            {{content}}
    </a>
    <input 
        v-if="isSubmit"
        type="submit" 
        :disabled="disabled"
        :class="buttonClasses"
        class="cursor-pointer " 
        :value="content">

</template>
